<template>
  <div class="mobile_index">
    <myHeader :isDark="false" />
    <!-- 设计即实现部分 -->
    <div class="design_implement">
      <p>设计即实现</p>
    </div>
    <!-- 视频部分 -->
    <div class="video">
      <video id="video1" style="width: 100%" autoplay muted loop playsinline webkit-playsinline x5-playsinline
        x-webkit-airplay="allow"
        poster="https://download.hecoos.com/enlightv/2025-37/1e148a3d54641a6a75703a1922f8c229.mp4?x-oss-process=video/snapshot,t_1000,m_fast"
        src="https://download.hecoos.com/enlightv/2025-37/1e148a3d54641a6a75703a1922f8c229.mp4"></video>
    </div>

    <!-- hecoos Studio部分 -->
    <div class="hecoos_studio">
      <p style="
          color: #706e73;
          font-weight: 700;
          font-size: 16px;
          margin-bottom: 5px;
        " class="hecoos_studio_p">
        hecoos Studio
      </p>
      <p style="
          color: #fff;
          font-weight: 700;
          font-size: 34px;
          letter-spacing: 1px;
          margin-bottom: 20px;
        " class="hecoos_studio_h mobileTitle" >
        实现设计与现场执行的无缝对接
      </p>

      <div class="hecoos_studio_content">
        <div class="hecoos_studio_content_left">
          <p @click="jumpTo('/studio')">三维场景预演</p>
          <p @click="jumpTo('/studio')">投影光路设计</p>
          <p @click="jumpTo('/studio')">灯光预演与预编程</p>
          <p @click="jumpTo('/studio')">导演系统</p>
          <p @click="jumpTo('/studio')">现场控制</p>
        </div>

        <!-- <div class="hecoos_studio_content_right">
          <div class="hecoos_img">
            <img style="width: 90%" src="@/asset/index/hecoosImg.png" alt="" />
          </div>
          <div class="hecoos_btn">
            <button @click="jumpTo('/1')">开启免费体验</button>
            <button @click="jumpTo('/2')">了解更多</button>
          </div>
        </div> -->
        <div class="hecoos_btn">
          <button @click="handleClickStudioLink()">开启免费体验</button>
          <button @click="jumpTo('/studio')">了解更多</button>
        </div>
      </div>
    </div>

    <!-- hecoos xR / VP部分 -->
    <div class="hecoos_xr_vp">
      <p style="
          color: #24272a;
          font-weight: 700;
          font-size: 16px;
          margin-bottom: 10px;
        " class="hecoos_xr_vp_p">
        hecoos xR / VP
      </p>
      <p style="
          color: #24272a;
          font-weight: 700;
          font-size: 34px;
          letter-spacing: 1px;
          margin-bottom: 20px;
          width: 80%;
        " class="hecoos_xr_vp_h mobileTitle">
        于虚实之间绘制无界之景
      </p>
      <img width="100%" style="border-radius: 15px"
        src="https://download.hecoos.com/enlightv/2025-17/b47a0de71e01928151e04092b491d177.gif" alt="" />
      <button @click="jumpTo('/virtualProduction')">进一步了解</button>
    </div>

    <!-- hecoos Server部分 -->
    <div class="hecoos_server">
      <p style="
          color: #fff;
          font-weight: 700;
          font-size: 16px;
          margin-bottom: 10px;
        " class="hecoos_server_p">
        hecoos Server
      </p>
      <p class="Server_title">现场播控与虚拟制作的呈现核心</p>
      <!-- <img
        width="100%"
        src="@/asset/mobile/index/hecoos_server_Img.png"
        alt=""
      /> -->
      <video autoplay muted ref="hecoosVideo" width="100%" playsinline webkit-playsinline x5-playsinline
        x-webkit-airplay="allow"
        src="https://download.hecoos.com/enlightv/2025-10/5041d9a4efe8822b28ec28af02b8213f.mp4"></video>
      <div class="hecoos_content">
        <p class="hecoos_content_title ">探索产品</p>
        <div class="hecoos_content_item">
          <div class="hecoos_content_item_left">
            <p class="hecoos_content_item_title1">Server-D</p>
            <p class="text1">
              最大限度管控从展演的灵感到最终落地 呈现的各个环节
            </p>
          </div>
          <button @click="jumpTo('/mediaServer?section=0#tab')">进一步了解</button>
        </div>

        <div class="hecoos_content_item">
          <div class="hecoos_content_item_left">
            <p class="hecoos_content_item_title2">Server-C</p>
            <p class="text1">虚拟制作拍摄流程中的“核心枢纽”</p>
          </div>
          <button @click="jumpTo('/mediaServer?section=1#tab')">进一步了解</button>
        </div>

        <div class="hecoos_content_item" style="border-bottom: none">
          <div class="hecoos_content_item_left">
            <p class="hecoos_content_item_title3">Server-R</p>
            <p class="text1">超强渲染能力亦能为虚拟内容创作者 提供贴心保障</p>
          </div>
          <button @click="jumpTo('/mediaServer?section=2#tab')">进一步了解</button>
        </div>
      </div>
    </div>

    <!-- 视频教程部分 -->
    <div class="video_course">
      <div class="video_course_wenB">
        <p style="color: #fff; font-size: 26px; font-weight: 700" class="video_course_p  mobileTitle">视频教程</p>
<!--        <p style="-->
<!--            margin-top: 8px;-->
<!--            font-size: 14px;-->
<!--            color: rgba(255, 255, 255, 0.64);-->
<!--            font-weight: 300;-->
<!--          " class="video_course_sp">-->
<!--          探索专家创建的在线视频-->
<!--        </p>-->
      </div>
      <div class="video_course_img">
        <img src="@/asset/mobile/index/video_course.png" alt="" />
        <p class="video_course_wenA mobileTitle">走进 <span class="mobileTitle">全新工作方法。</span></p>
        <div class="play" @click="jumpTo('/video_tutorial')">
          <div class="play_icon">

          </div>
          <!-- <img src="@/asset/mobile/index/btn.png" alt="" /> -->
        </div>
      </div>
      <div style="width: 100%; height: 40px"></div>
    </div>

    <!-- 案例展示部分 -->
    <div class="case_show">
      <p style="color: #fff; font-size: 26px; font-weight: 700" class="case_show_p mobileTitle">案例展示</p>
      <p style="
          margin-top: 8px;
          font-size: 14px;
          color: rgba(255, 255, 255, 0.64);
          font-weight: 300;
          margin-bottom: 20px;
        " class="case_show_p1">
        关于我们的最新消息
      </p>
      <van-swipe :autoplay="3000" :height="160" :loop="false" :show-indicators="false">
        <van-swipe-item v-for="(item, index) in bannerList" :key="index" @click="showVideo(item.link)"
          class="van_swipe_item">
          <img :src="item.cover" alt="">
          <p>{{ item.title }}</p>
        </van-swipe-item>
      </van-swipe>
      <button class="case_show_btn" @click="jumpTo('/casepresentation')">查看全部案例</button>
    </div>

    <!-- <myListen /> -->
    <myFooter />
    <videoPlayback v-if="showVideoPlayer" @close="handleCloseVideo" :videoUrl="videoUrl" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import myHeader from "@/components/mobile/myHeader.vue";
import myFooter from "@/components/mobile/myFooter.vue";
// import myListen from "@/components/mobile/myListen.vue";
import videoPlayback from "@/components/en_mobile/videoPlayback.vue";
import { getCaseList } from "@/api/api";
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
export default {
  data() {
    return {
      // baseUrl: 'https://www.hecoos.com/',
      bannerList: [],
      showVideoPlayer: false,
      videoUrl: 'https://download.hecoos.com/enlightv/2025-11/3682ee8f4d99851fede9ebb32b9f1b10.mp4',
    };
  },
  created() {
    this.getCaseLists();
  },
  mounted() {
    // 处理微信环境下视频自动播放
    if (
      typeof WeixinJSBridge === "object" &&
      typeof WeixinJSBridge.invoke === "function"
    ) {
      WeixinJSBridge.invoke("getNetworkType", {}, function (e) {
        const video1 = document.getElementById("video1");
        const video2 = document.getElementById("video2");
        if (video1) video1.play();
        if (video2) video2.play();
      });
    } else {
      document.addEventListener(
        "WeixinJSBridgeReady",
        function () {
          const video1 = document.getElementById("video1");
          const video2 = document.getElementById("video2");
          if (video1) video1.play();
          if (video2) video2.play();
        },
        false
      );
    }
    const video = this.$refs.hecoosVideo;
    const options = {
      root: null,
      rootMargin: "0px",
      // 当视频显示一半时触发回调
      threshold: 0.5,
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          video.currentTime = 0; // 重置视频播放进度
          video.play().catch((error) => {
            console.log("视频播放失败:", error);
          });
        } else {
          video.pause(); // 视频离开视口时暂停
        }
      });
    }, options);

    this.observer.observe(video);

    video.addEventListener("ended", () => {
      video.pause(); // 视频播放结束后定格
    });
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
    const video = this.$refs.hecoosVideo;
    video.removeEventListener("ended", () => {
      video.pause();
    });
  },
  components: {
    myHeader,
    myFooter,
    // myListen,
    videoPlayback,
  },
  computed: {
    ...mapState(["adminUserInfo"]),
  },
  methods: {
    handleClickStudioLink(){
      if(this.adminUserInfo && this.adminUserInfo.id){
        this.jumpTo('/personalCenter')
      }else{
        this.jumpTo('/Register')
      }
    },
    jumpTo(path) {
      // console.log(path);
      this.$router.push(path)
    },
    // 显示视频播放器
    showVideo(url) {
      this.videoUrl = url;
      this.showVideoPlayer = true;
      document.body.style.overflow = 'hidden'; // 禁止页面滚动
    },
    // 处理关闭视频
    handleCloseVideo() {
      this.showVideoPlayer = false;
      document.body.style.overflow = 'auto'; // 恢复页面滚动
    },
    getCaseLists() {
      let postData = {
        page: 1,
        limit: 8,
        type: '101'
      };
      getCaseList(postData).then((res) => {
        if (res.code === 200) {
          this.bannerList = res.data;
        }
      });
    }
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/mobile_xty.scss";
</style>
